module.exports = __webpack_public_path__ + "static/img/404.9f74df08.jpg";